import React from 'react';
import { Card, Empty } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { Chart } from 'react-google-charts';
import { Button } from '../../../design-system';

const COLORS = ['#1B1B1B', '#FED230', '#d9d9d9'];

const GenderPieChart = ({ data = [], onSegmentClick, onExportCSV }) => {
    if (!data || data.length === 0) {
        return (
            <Card title="Gender Distribution" className="chart-card">
                <Empty description="No data available" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </Card>
        );
    }

    const chartData = [['Gender', 'Count']];
    const colors = [];

    for (const item of data) {
        chartData.push([item.gender, item.count]);
        if (item.gender === 'Male') colors.push(COLORS[0]);
        else if (item.gender === 'Female') colors.push(COLORS[1]);
        else colors.push(COLORS[2]);
    }

    const options = {
        pieHole: 0.4,
        legend: {
            position: 'right',
            alignment: 'center',
            textStyle: { fontSize: 12 },
        },
        pieSliceText: 'value',
        pieSliceTextStyle: { fontSize: 12 },
        colors,
        chartArea: { width: '90%', height: '80%' },
        backgroundColor: 'transparent',
    };

    const chartEvents = onSegmentClick ? [
        {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
                const selection = chartWrapper.getChart().getSelection();
                if (selection.length > 0) {
                    const row = selection[0].row;
                    const item = data[row];
                    if (item) onSegmentClick(item);
                }
            },
        },
    ] : [];

    return (
        <Card
            title="Gender Distribution"
            className="chart-card"
            extra={
                onExportCSV && (
                    <Button
                        size="small"
                        variant="secondary"
                        icon={<DownloadOutlined />}
                        onClick={() => onExportCSV('gender', data)}
                        title="Download CSV"
                    />
                )
            }
        >
            <Chart
                chartType="PieChart"
                data={chartData}
                options={options}
                width="100%"
                height="300px"
                chartEvents={chartEvents}
            />
        </Card>
    );
};

export default GenderPieChart;
